import { combineReducers } from "@reduxjs/toolkit";
import dashboardApi from "../apis/edge-dashboard";
import loginApi from "../apis/login";
import quickActionsSlice from "./quickActionsSlice/quickActionsSlice";
const rootReducer = combineReducers({
  // add reducers here ...
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [loginApi.reducerPath]: loginApi.reducer,
  [quickActionsSlice.name]:quickActionsSlice.reducer
});

// export const reduxMiddlewares = [
//     // add middlewares here ...
//     dashboardApi.middleware,
//     folderManagementApi.middleware,
//     manageSaveSearchApi.middleware,
//     loginApi.middleware,
//     masterDataApi.middleware,
// ]

export default rootReducer;
